/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Button, message, Modal } from 'antd';
import { IDataModal } from '@/interfaces/dataModal';
import { IInboundItem } from '@/interfaces/inbound';
import InboundItemTable from './inbound-item-table';
import { useMutation } from '@tanstack/react-query';
import { updateInboundStatus } from '@/adapters/inbound';
import { EInboundStatus } from '@/enums/EInbound';

interface IProps {
  dataModal?: IDataModal<IInboundItem[]>;
  handleOk: () => void;
  handleCancel: () => void;
}

const InboundItemTableModal = ({
  dataModal,
  handleOk,
  handleCancel,
}: IProps) => {
  const mutations = useMutation({
    mutationFn: async (id: number) => await updateInboundStatus(id),
    mutationKey: ['update-inbound-status'],
    onSuccess: data => {
      if (data.status === 200) {
        message.success('approve สำเร็จ');
        handleOk();
      }
    },
    onError: error => {
      console.log('error', error);
    },
  });

  const handleUpdate = async () => {
    await mutations.mutateAsync(Number(dataModal?.optional.id));
  };

  return (
    <Modal
      title={'Invoice Item'}
      open={dataModal?.open}
      onOk={() => handleOk()}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      width={1400}
      footer={false}
    >
      <div className="flex flex-col gap-3">
        <InboundItemTable
          isView
          lenght={1350}
          loading={false}
          items={dataModal?.item || []}
          onOk={() => {
            console.log();
          }}
        />
        {dataModal?.optional?.status == EInboundStatus.PENDING && (
          <div className="flex justify-end">
            <Button type="primary" onClick={() => handleUpdate()}>
              Approve
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default InboundItemTableModal;
